import { ReactNode } from 'react';
import styled from 'styled-components';
import { Layout } from '@increasecard/increase-core';
import { Notifications } from './Notifications';
import { SubscriptionRequestNotification } from './features/subscription/SubscriptionRequestNotification';
import { NavBar } from './components/NavBar/NavBar';
import { useAccount } from './globalQueries/Queries';

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;

  .content-outlet {
    background-color: var(--color-gray-graySLight);
    flex: 1;
    height: calc(100vh - 56px);
    padding: 1rem;
    overflow-y: auto;
  }
`;

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  min-width: 0;
`;

export interface AppHeaderProps {
  children: ReactNode;
}

export function AppHeader({ children }: AppHeaderProps): JSX.Element {
  const { data } = useAccount();
  return (
    <AppContainer>
      <SubscriptionRequestNotification />
      <Notifications />
      <Layout tabs={null} profileImageUrl={data?.branding_settings?.icon_url}>
        <ContentWrapper>
          <NavBar />
          <div className="content-outlet">{children}</div>
        </ContentWrapper>
      </Layout>
    </AppContainer>
  );
}
